import { Controller } from "@hotwired/stimulus"

// Handles month navigation for the attendance calendar.
// Navigation is done via standard links with Turbo — this controller
// simply provides the classroom selector behavior.
export default class extends Controller {
  static targets = ["classroomSelect"]

  changeClassroom(event) {
    const classroomId = event.target.value
    const url = new URL(window.location.href)
    url.searchParams.set("classroom_id", classroomId)
    Turbo.visit(url.toString())
  }
}
